import styled from 'styled-components'

import { pxToRem } from '../../theme'
import Link from '../Link'
import Icon from '../Icon'

export const Container = styled(Link)`
  --transition-duration: 0.3s;
  --border-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(8)} ${pxToRem(24)};
  min-height: ${pxToRem(70)};
  border: 1px solid var(--border-color);
  color: ${({ theme }) => theme.colors.black};
  transition: border-color var(--transition-duration)
    cubic-bezier(0.76, 0, 0.24, 1);
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:not(:disabled):active,
  &:not(:disabled):focus,
  &:not(:disabled):hover {
    --border-color: rgba(0, 0, 0, 1);
  }
`

export const Label = styled.span`
  ${({ theme }) => theme.textStyles.m375_body}
  font-weight: 500;
`
export const _Icon = styled(Icon)`
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`

export const Details = styled.span`
  ${({ theme }) => theme.textStyles.m375_body}
  margin-inline-start: auto;
`
